import client from '../client';
import { BASE_ENDPOINTS, SERVICES, VERSIONS } from '../common/constants';

// Define the base endpoint for monitor
const SUB_PROJECT_PEDOLOGY_MONITOR_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.SUB_PROJECT,
  VERSIONS.V1,
  'monitor',
  false // No tenant ID in the base URL
);

// Define the base endpoint for districts
const SUB_PROJECT_PEDOLOGY_DISTRICTS_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.SUB_PROJECT,
  VERSIONS.V1,
  'districts',
  false // No tenant ID in the base URL
);

// Define the base endpoint for taluks
const SUB_PROJECT_PEDOLOGY_TALUKS_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.SUB_PROJECT,
  VERSIONS.V1,
  'taluks',
  false // No tenant ID in the base URL
);

// Define the base endpoint for villages
const SUB_PROJECT_PEDOLOGY_VILLAGES_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.SUB_PROJECT,
  VERSIONS.V1,
  'villages',
  false // No tenant ID in the base URL
);

// API functions
export const getVillageLists = villageIDs =>
  client.post(`${SUB_PROJECT_PEDOLOGY_MONITOR_BASE}/soil/table/`, villageIDs);

export const getDistricts = ({ state, tenant }) =>
  client.get(
    `${SUB_PROJECT_PEDOLOGY_DISTRICTS_BASE}/${state}/?tenant_id=${tenant}`
  );

export const getTaluk = ({ state, district }) =>
  client.get(`${SUB_PROJECT_PEDOLOGY_TALUKS_BASE}/${state}/${district}/`);

export const getVillage = ({ state, district, taluk }) =>
  client.get(
    `${SUB_PROJECT_PEDOLOGY_VILLAGES_BASE}/${state}/${district}/${taluk}/`
  );

export const getMonitor = villageID =>
  client.get(`${SUB_PROJECT_PEDOLOGY_MONITOR_BASE}/${villageID}`);

export const getExportAllData = params =>
  client.post(
    `${SUB_PROJECT_PEDOLOGY_MONITOR_BASE}/soil/table/export/`,
    params
  );
